export default
{
    methods:
    {
        dateFormatFn( classes, date )
        {
            let dt      = new Date(date); dt.setHours(0, 0, 0, 0);
            let start   = new Date(this.start); start.setHours(0, 0, 0, 0);
            let end     = new Date(this.end); end.setHours(0, 0, 0, 0);

            classes['in-range'] = dt >= start && dt <= end

            return this.dateFormat ? this.dateFormat(classes, date) : classes
        },

        changeLeftMonth( value )
        {
            let newDate = new Date( value.year, value.month - 1, 1 );

            this.monthDate = newDate;

            if( this.linkedCalendars || ( this.$dateUtil.yearMonth( this.monthDate ) >= this.$dateUtil.yearMonth( this.nextMonthDate ) ) )
            {
                this.nextMonthDate = this.$dateUtil.validateDateRange( this.$dateUtil.nextMonth( newDate ), this.minDate, this.maxDate );

                if( this.$dateUtil.yearMonth( this.monthDate ) === this.$dateUtil.yearMonth( this.nextMonthDate ) )
                {
                    if( this.singleDatePicker )
                    {
                        this.monthDate = this.$dateUtil.validateDateRange( this.$dateUtil.nextMonth( this.monthDate ), this.minDate, this.maxDate );
                    }
                    else
                    {
                        this.monthDate = this.$dateUtil.validateDateRange( this.$dateUtil.prevMonth( this.monthDate ), this.minDate, this.maxDate );
                    }
                }
            }

            this.$emit( 'change-month', this.monthDate, 0 );
        },

        changeRightMonth( value )
        {
            let newDate = new Date( value.year, value.month - 1, 1 );

            this.nextMonthDate = newDate

            if( this.linkedCalendars || ( this.$dateUtil.yearMonth( this.nextMonthDate ) <= this.$dateUtil.yearMonth( this.monthDate ) ) )
            {
                this.monthDate = this.$dateUtil.validateDateRange( this.$dateUtil.prevMonth( newDate ), this.minDate, this.maxDate );

                if( this.$dateUtil.yearMonth( this.monthDate ) === this.$dateUtil.yearMonth( this.nextMonthDate ) )
                {
                    this.nextMonthDate = this.$dateUtil.validateDateRange( this.$dateUtil.nextMonth( this.nextMonthDate ), this.minDate, this.maxDate );
                }
            }

            this.$emit( 'change-month', this.monthDate, 1 );
        },

        normalizeDatetime( value, oldValue )
        {
            let newDate = new Date( value );

            if( this.timePicker && oldValue )
            {
                newDate.setHours( oldValue.getHours() );
                newDate.setMinutes( oldValue.getMinutes() );
                newDate.setSeconds( oldValue.getSeconds() );
                newDate.setMilliseconds( oldValue.getMilliseconds() );
            }

            return newDate;
        },

        dateClick( value )
        {
            if( this.readonly )
            {
                return false;
            }

            if( this.in_selection )
            {
                this.in_selection = false;

                this.$emit( 'startSelection', this.start );

                /*
                this.end = this.normalizeDatetime( value, this.end );

                if( this.end < this.start )
                {
                    this.in_selection = true;
                    this.start        = this.normalizeDatetime( value, this.start );

                    this.$emit( 'startSelection', this.start );
                }
                */

                if( !this.in_selection )
                {
                    this.$emit( 'finishSelection', this.end );

                    this.onSelect();

                    if( this.autoApply )
                    {
                        this.clickedApply();
                    }
                }
            }
            else
            {
                this.start  = this.normalizeDatetime( value, this.start );
                this.end    = this.normalizeDatetime( value, this.end );

                this.rootStart = this.start;

                if( !this.singleDatePicker || this.singleDatePicker === 'range' )
                {
                    this.in_selection = true;

                    this.$emit( 'startSelection', this.start );
                }
                else
                {
                    this.onSelect();

                    if( this.autoApply )
                    {
                        this.clickedApply();
                    }
                }
            }
        },

        hoverDate( value )
        {
            if( this.readonly )
            {
                return false;
            }

            let dt_end   = this.normalizeDatetime( value, this.end );
            let dt_start = this.normalizeDatetime( value, this.start );

            if( this.in_selection )
            {
                if( this.rootStart <= dt_end )
                {
                    this.start = this.rootStart > this.start ? this.normalizeDatetime( this.rootStart, this.start ) : this.start;
                    this.end   = dt_end;
                }

                if( this.rootStart >= dt_start )
                {
                    this.start = dt_start;
                    this.end   = this.rootStart < this.end ? this.normalizeDatetime( this.rootStart, this.end ) : this.end;
                }
            }

            this.$emit( 'hoverDate', value );
        },

        onClickPicker()
        {
            if( !this.disabled )
            {
                this.togglePicker(null, true);
            }
        },

        togglePicker( value, event )
        {
            if( typeof value === 'boolean' )
            {
                this.open = value;
            }
            else
            {
                this.open = !this.open;
            }

            if( event === true )
            {
                this.$emit( 'toggle', this.open, this.togglePicker );
            }
        },

        clickedApply()
        {
            this.togglePicker(false, true);

            const starDate = new Date( this.start );
            const endDate = new Date( this.end );

            if( starDate && starDate instanceof Date && !this.timePicker )
            {
                starDate.setHours(0, 0, 0, 0);
            }

            if( endDate && endDate instanceof Date && !this.timePicker )
            {
                endDate.setHours(23, 59, 59, 999);
            }

            if( !this.singleDatePicker || this.singleDatePicker === 'range' )
            {
                this.$emit( 'update:modelValue', { startDate: starDate, endDate: endDate });
            }
            else
            {
                this.$emit( 'update:modelValue', { startDate: starDate });
            }
        },

        clickCancel()
        {
            if( this.open )
            {
                let startDate = this.modelValue.startDate;
                let endDate   = this.modelValue.endDate;

                this.start = startDate ? new Date( startDate ) : null;
                this.end   = endDate ? new Date( endDate ) : null;

                this.in_selection = false;

                this.togglePicker(false, true );
            }
        },

        onSelect()
        {
            this.$emit( 'select', { startDate: this.start, endDate: this.end });
        },

        clickAway( $event )
        {
            if( $event && $event.target && !this.$el.contains( $event.target ) && this.$refs.dropdown && !this.$refs.dropdown.contains( $event.target ) )
            {
                this.clickCancel()
            }
        },

        clickRange( value )
        {
            this.in_selection = false;

            if( this.$dateUtil.isValidDate( value[0] ) && this.$dateUtil.isValidDate( value[1] ) )
            {
                this.start  = this.$dateUtil.validateDateRange( new Date(value[0]), this.minDate, this.maxDate );
                this.end    = this.$dateUtil.validateDateRange( new Date(value[1]), this.minDate, this.maxDate );

                this.changeLeftMonth({ month: this.start.getMonth() + 1, year: this.start.getFullYear() });

                if( this.linkedCalendars === false )
                {
                    this.changeRightMonth({ month: this.end.getMonth() + 1, year: this.end.getFullYear() });
                }
            }
            else
            {
                this.start = null; this.end = null;
            }

            this.onSelect();

            if( this.autoApply )
            {
                this.clickedApply()
            }
        },

        onUpdateStartTime( value )
        {
            let start = new Date( this.start );

            start.setHours( value.hours );
            start.setMinutes( value.minutes );
            start.setSeconds( value.seconds );

            this.start = this.$dateUtil.validateDateRange( start, this.minDate, this.maxDate );

            if( this.autoApply )
            {
                if( !this.singleDatePicker || this.singleDatePicker === 'range' )
                {
                    this.$emit( 'update:modelValue', { startDate: this.start, endDate: this.end });
                }
                else
                {
                    this.$emit( 'update:modelValue', { startDate: this.start });
                }
            }
        },

        onUpdateEndTime( value )
        {
            let end = new Date( this.end );

            end.setHours( value.hours );
            end.setMinutes( value.minutes );
            end.setSeconds( value.seconds );

            this.end = this.$dateUtil.validateDateRange( end, this.minDate, this.maxDate );

            if( this.autoApply )
            {
                if( !this.singleDatePicker || this.singleDatePicker === 'range' )
                {
                    this.$emit( 'update:modelValue', { startDate: this.start, endDate: this.end });
                }
                else
                {
                    this.$emit( 'update:modelValue', { startDate: this.start });
                }
            }
        },

        handleEscape( e )
        {
            if( this.open && e.keyCode === 27 && this.closeOnEsc )
            {
                this.clickCancel();
            }
        }
    }
}